import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modale-reset-password-success',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-card">
      <div class="modal-icon modal-icon-success">
        <i class="bi bi-check-lg"></i>
      </div>
      <div class="modal-title">Password cambiata</div>
      <div class="modal-subtitle">La tua password è stata modificata con successo.</div>
      <button class="btn-kf-primary mt-3" (click)="activeModal.close()">OK</button>
    </div>
  `
})
export class ModaleResetPasswordSuccessComponent implements OnInit {
  activeModal = inject(NgbActiveModal);

  ngOnInit() {
    setTimeout(() => {
      this.activeModal.close();
    }, 2000);
  }
}
